import axios from 'axios'
let formatFileMixin = {
  methods: {
    formatAttachment (files) {
      return files.map((file, index) => {
        if (file.includes(',')) {   //视频类型
          let videoInfo = file.split(',');
          return {
            id: index,
            url: videoInfo[0],
            src: 'https://www.erplus.co/image' + videoInfo[0],
            sourceUrl: videoInfo[1],
            isUploaded: true
          }

        } else {   //图片类型
          return {
            id: index,
            url: file,
            src: 'https://www.erplus.co/image' + file,
            isUploaded: true
          }
        }
      })
    },
    formatFileArrayToString (files) {
      if (Object.prototype.toString.call(files) === '[object Array]') {
        return files.map(file => {
          if (file.sourceUrl) {   //sourceUrl属性表示视频的资源地址
            return file.url.concat(',', file.sourceUrl)
          }
          return file.url
        })
      } else {
        return files
      }
    }
  }
}

let fetchUploadFileMixin = {
  data () {
    return {
      isAllFilesUploaded: true
    }
  },
  methods: {
    fetchUploadPicture (imageList, callback) {
      // 上传图片
      let formData = new FormData()
      if(imageList.length > 0) {
        let isAllFilesUploaded = true
        imageList.forEach((image) => {
          if (image.file) {
            formData.append('file[]', image.file)
          }
          if (!image.isUploaded) {
            isAllFilesUploaded = false
          }
        })
        if (isAllFilesUploaded) {
          console.log('isAllFilesUploaded')
          this.isAllFilesUploaded = isAllFilesUploaded
          callback()
          return false
        } else {
          this.isAllFilesUploaded = false
        }
      }
      axios({
        method: 'post',
        url: '//www.erplus.co/upload/uploadAttachment',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      }).then(pictureRes => {
        pictureRes = pictureRes.data
        if (pictureRes.respCode === '000') {
          if (pictureRes.item.length > 0) {
            // 上传图片，并将未上传过的图片路径 替换为已上传的路径
            imageList.forEach((file, index) => {
              if (file.isUploaded) {

              } else {
                imageList.splice(index, 1, {
                  id: index,
                  url: pictureRes.item[0],
                  src: 'https://www.erplus.co/image' + pictureRes.item[0],
                  isUploaded: true
                })
                pictureRes.item.shift()
              }
            })
            this.isAllFilesUploaded = true
            callback()
          }
        } else {
          this.$message.warning(pictureRes.respDesc || '上传图片失败')
        }
      })
    }
  }
}

export {
  formatFileMixin,
  fetchUploadFileMixin
}



// WEBPACK FOOTER //
// ./src/mixins/format-file.js